export const UMB_PROPERTY_EDITOR_DATA_SOURCE_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.PropertyEditorDataSourceItem';
export const UMB_PROPERTY_EDITOR_DATA_SOURCE_ITEM_STORE_ALIAS = 'Umb.Store.PropertyEditorDataSourceItem';
export { UMB_PROPERTY_EDITOR_DATA_SOURCE_ITEM_STORE_CONTEXT } from './item.store.context-token.js';
